import * as yup from 'yup'

export class PersonDeclarantInformationDto {
  declarantCapacity?: string = undefined
  declarantSignatureFileName?: string = undefined
  declarantSignatureFile?: File = undefined
}

export const personDeclarantInformationValidationSchema = yup.object({
  declarantCapacity: yup
    .string()
    .max(200, 'Declarant Capacity cannot be more than 200 characters.')
    .required('Declarant Capacity is required.'),
  declarantSignatureFile: yup
    .mixed()
    // @ts-ignore
    .test('Signature is required.', (value: File) => value)
    .required('Signature is required.')
})
